import React from 'react';
import { motion } from 'framer-motion';
import { Target, Check } from 'lucide-react';
import { Button } from './Button';
import { PaymentInfo } from './PaymentInfo';
export function WhoIsItFor() {
  const criteria = ['Entrenás y tu agarre falla primero', 'Querés levantar más sin depender de straps', 'Hacés fuerza, crossfit, combate o calistenia', 'Querés rendimiento real, no solo estética'];
  return <section className="py-24 bg-dark-900 relative overflow-hidden" data-id="element-217">
      {/* Background graphic */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-full opacity-5 pointer-events-none" data-id="element-218">
        <Target className="w-full h-full" data-id="element-219" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-220">
        <div className="max-w-4xl mx-auto bg-dark-800 border border-dark-700 rounded-3xl p-8 md:p-16 shadow-2xl" data-id="element-221">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-222">
            <h2 className="text-4xl md:text-5xl font-oswald font-bold text-white mb-4" data-id="element-223">
              ¿ES ESTO PARA{' '}
              <span className="text-neon-cyan text-shadow-neon" data-id="element-224">VOS?</span>
            </h2>
          </motion.div>

          <div className="space-y-6 mb-12" data-id="element-225">
            {criteria.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="flex items-center gap-6 bg-dark-900 p-6 rounded-xl border border-dark-700" data-id="element-226">
                <div className="w-10 h-10 rounded-full bg-neon-cyan/10 flex items-center justify-center shrink-0 border border-neon-cyan/30" data-id="element-227">
                  <Check className="w-6 h-6 text-neon-cyan" data-id="element-228" />
                </div>
                <p className="text-lg md:text-xl text-gray-200 font-inter font-medium" data-id="element-229">
                  {item}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6
        }} className="flex justify-center" data-id="element-230">
            <Button data-id="element-231">SÍ, ESTO ES PARA MÍ</Button>
            <PaymentInfo data-id="element-232" />
          </motion.div>
        </div>
      </div>
    </section>;
}